export default __webpack_public_path__ + "static/media/mongoose.4bb8f61c.jpg";